import { Component, Input } from '@angular/core';
import { SeminarModel } from '../../../../../models/seminar.model';
import { SponsorCardModel } from '../../../../../models/sponsor-card.model';
import { TrainingCategoryModel } from '../../../../../models/training-category.model';
import { getUserFullName } from '../../../../../utils/user.utils';

@Component({
  selector: 'app-seminar-preview',
  templateUrl: './seminar-preview.component.html',
  styleUrl: './seminar-preview.component.scss',
  standalone: false,
})
export class SeminarPreviewComponent {
  @Input() seminar: SeminarModel;
  @Input() seminarCategory: TrainingCategoryModel;
  @Input() sponsorCards: SponsorCardModel[];

  constructor() {}

  public getUserFullName = getUserFullName;

  public getSeminarFobiPoints(seminar: SeminarModel): number {
    return seminar.dateSeries.reduce(
      (total, series) =>
        total +
        series.dates.reduce((sum, date) => sum + (date.fobiPoints || 0), 0),
      0
    );
  }
}
